import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';

import Section from '@sections/SectionWrapper';

import ButtonBlock from '../blocks/ButtonBlock';
import MainButton from '@elements/MainButton';

import {
	SubheadingH1,
	BodyText20,
	SectionOverline,
} from '@styled-components/Typography';
import StyledTextBlocks from '@styled-components/StyledTextBlocks';

const TextHeroWrapper = styled(Section)`
	text-align: center;
	margin-top: ${({ theme }) => `calc(${theme.fixedHeights.navBar}px)`};
`;

const HeroHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin: 0 auto;
	justify-content: center;
	align-items: center;

	${({ theme }) => theme.mediaQuery.breakpointLg} {
		margin: 0 auto;
	}
`;

const HeroH1 = styled(SubheadingH1)`
	color: ${({ theme, darkBackground }) =>
		darkBackground ? theme.colors.white.main : theme.colors.black.main};
	text-wrap: balance;
`;

const SubheaderWrapper = styled.div`
	p {
		color: ${({ theme, darkBackground }) =>
			darkBackground ? theme.colors.white.main : theme.colors.black.main};
		margin: 0 auto;
		${({ theme }) => theme.mediaQuery.breakpointLg} {
			width: 50vw;
		}
	}
`;

const ButtonWrapper = styled.div`
	margin: 4rem auto 0;
`;

const TextHero = ({
	backgroundImage,
	backgroundColor,
	header,
	subheader,
	buttons,
	heroHasVideo,
	pageHasForm,
	className,
	id,
	fullWidthHeader,
	formOffset,
	anchorLink,
	anchorText,
	overline,
	...props
}) => {
	const darkBackground = backgroundImage;
	return (
		<TextHeroWrapper
			backgroundImage={backgroundImage}
			backgroundColor={backgroundColor}
			// heroHasVideo={heroHasVideo}
			// noBottomPadding={heroHasVideo}
			className={className}
			id={id}
			{...props}
		>
			<HeroHeader className="hero__text" fullWidthHeader={fullWidthHeader}>
				{overline && <SectionOverline>{overline}</SectionOverline>}
				{header && <HeroH1 darkBackground={darkBackground}>{header}</HeroH1>}
				{subheader && (
					<SubheaderWrapper darkBackground={darkBackground}>
						{subheader.raw ? (
							<StyledTextBlocks
								textBlock={subheader}
								options={{ bodySize: 20 }}
							/>
						) : (
							<BodyText20>
								{subheader.childMarkdownRemark
									? parse(subheader.childMarkdownRemark.html)
									: subheader}
							</BodyText20>
						)}
					</SubheaderWrapper>
				)}
				{(pageHasForm || buttons) && (
					<ButtonWrapper>
						{pageHasForm && (
							<MainButton
								anchorLink={anchorLink || `#hubspotForm`}
								offset={formOffset || 350}
							>
								{anchorText || 'Get a Quote'}
							</MainButton>
						)}
						{buttons && <ButtonBlock buttons={buttons} />}
					</ButtonWrapper>
				)}
			</HeroHeader>
		</TextHeroWrapper>
	);
};

export default TextHero;
